import React from "react";
import "./PrivacyPolicy.scss";

export const PrivacyPolicy = () => {
  return (
    <div className="text" style={{ padding: "10px" }}>
      <h1>Privacy Policy</h1>
      <p>
        Etienne Thompson &#40;"Developer", "we", "us"&#41; provides this
        Privacy Policy to explain how it collects, stores, and uses the
        information collected in connection with Developer's software
        applications, and websites &#40;collectively, "services"&#41;.
        Developer respects the privacy of their users and is committed to
        protecting the user's information. You have a right to know our
        practices regarding the information we may collect and use when you use
        our services.
      </p>
      <p>This Privacy Policy is effective as of August 19, 2023.</p>
      <p>The types of information we collect and how we collect it:</p>
      <h2>Personal Information</h2>
      <p>We do not collect any personal information.</p>
      <h2>Non-personal information</h2>
      <p>
        Developer reserves the right to collect anonymous information for
        research and analysis. This information is generic in nature and cannot
        be used to individually identify a user. This information is collected
        each time a user runs one of our services.
      </p>
      <h2>What we do with the non-personal information we collect:</h2>
      <p>
        Developer uses non-personal information to conduct research and
        analysis.
      </p>
      <h2>Children</h2>
      <p>
        We do not use the services to knowingly solicit data from or market to
        children under the age of 13. If a parent or guardian becomes aware
        that his or her child has provided us with information without their
        consent, he or she should contact us at et@etiennethompson.com. We will
        delete such information from our files within a reasonable time.
      </p>
      <h2>Changes to this Privacy Policy</h2>
      <p>
        We will periodically update this privacy policy to reflect changes in
        our information practices, and to add additional third party operators.
        Please check back regularly, as your continued use of our services
        indicate your acceptance of any changes to this policy.
      </p>
      <h2>Privacy Policy Contact Information</h2>
      <p>
        If you have any questions about our privacy policy, please contact us
        via et@etiennethompson.com.
      </p>
    </div>
  );
};
